import { z } from 'zod';
/**
 * The seven reactions. One per member per object; selecting a second replaces
 * the first (AC-ENGA-01.2).
 *
 * `disapprove` is not an afterthought — it is the structural counterweight that
 * docs/02 §1.2 principle 1 is built on.
 */
export const ReactionType = z.enum([
    'like',
    'approve',
    'disapprove',
    'support',
    'celebrate',
    'love',
    'funny',
]);
export const REACTION_TYPES = ReactionType.options;
/** Reactions shown in the tally strip, in design order. Excludes `like`. */
export const TALLY_REACTIONS = [
    'approve',
    'disapprove',
    'support',
    'celebrate',
    'love',
];
/** Denormalised counters carried on every content document (docs/06 §7.4). */
export const EngagementCounts = z.object({
    like: z.number().int().nonnegative(),
    approve: z.number().int().nonnegative(),
    disapprove: z.number().int().nonnegative(),
    support: z.number().int().nonnegative(),
    celebrate: z.number().int().nonnegative(),
    love: z.number().int().nonnegative(),
    funny: z.number().int().nonnegative(),
    comments: z.number().int().nonnegative(),
    /** Opposite Point of View — counted separately from comments (FR-ENGA-03). */
    opvs: z.number().int().nonnegative(),
    favourites: z.number().int().nonnegative(),
});
export const ZERO_ENGAGEMENT = {
    like: 0,
    approve: 0,
    disapprove: 0,
    support: 0,
    celebrate: 0,
    love: 0,
    funny: 0,
    comments: 0,
    opvs: 0,
    favourites: 0,
};
//# sourceMappingURL=engagement.js.map